import { selectAccountId } from "@/auth/authSlice";
import * as React from "react";
import { useSelector } from "react-redux";
import { selectHighlights } from "./bidSlice";

export default function HighlightCell({ cell, hover }) {
    const accountId = useSelector(selectAccountId);
    const highlights = useSelector(selectHighlights);
    const cellHighlights = highlights.filter(
        (h) => h.rowId == cell.rowId && h.columnId == cell.columnId,
    );
    const otherHighlights = cellHighlights.filter(
        (highlight) => highlight.accountId != accountId,
    );
    const highlightColor = cellHighlights[0]?.borderColor;
    if (otherHighlights.length == 0) {
        return;
    }
    return (
        <div
            onContextMenu={(e) => {
                e.preventDefault();
                // Show context menu
            }}
            style={{
                position: "absolute",
                width: "calc(100% - 3px)",
                height: "calc(100% - 3px)",
                top: 0,
                left: 0,
                border: `${highlightColor} 2px solid`,
                pointerEvents: "none",
            }}
        >
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        right: -2,
                        top: -15,
                        background: highlightColor,
                        fontSize: 9,
                        padding: 2,
                        paddingLeft: 4,
                        paddingRight: 4,
                        borderRadius: 2,
                    }}
                >
                    <span>
                        {otherHighlights.map((h) => h.accountName).join(", ")}
                    </span>
                </div>
            )}
        </div>
    );
}
